export const getMenuData = [
  {
    category: true,
    title: 'Panel de Control',
  },
  {
    title: 'Inicio',
    key: 'inicio',
    icon: 'fa fa-home',
    url: '/inicio',
    permission: 'all'
  },
  {
    category: true,
    title: 'Módulos',
  },
  {
    title: 'Agencias',
    key: 'agencias',
    icon: 'fa fa-users',
    url: '/admin/agencias',
    permission: '*'
  },
  {
    title: 'Almacén',
    key: 'almacen',
    icon: 'fa fa-cubes',
    url: '/almacen/cajas',
    children: [
      {
        title: 'cajas',
        key: 'cajas',
        url: '/almacen/cajas',
        permission: 'caja.listar'
      },
    ],
  },
  {
    title: 'Ingresos',
    key: 'ingresos',
    icon: 'fa fa-arrow-circle-up',
    url: '/almacen/ingresos',
    children: [
      {
        title: 'ver lista',
        key: 'ingresos',
        url: '/almacen/ingresos',
        permission: 'ingresos.listar'
      },
    ],
  },
  {
    title: 'Salidas',
    key: 'salidas',
    icon: 'fa fa-arrow-circle-down',
    url: '/almacen/salidas/salidas',
    children: [
      {
        title: 'ver lista',
        key: 'salidas',
        url: '/almacen/salidas',
        permission: 'salidas.listar'
      },
    ],
  },
  {
    title: 'Digital',
    key: 'digital',
    icon: 'fa fa-desktop',
    url: '/almacen/digital',
    permission: 'digital.listar'
  },
  {
    title: 'Reportes',
    key: 'reportes',
    icon: 'fa fa-line-chart',
    url: '/reportes',
    permission: 'caja.listar'
  },
  {
    category: true,
    title: 'Administración',
  },
  {
    title: 'Reportes',
    key: 'reportes',
    icon: 'fa fa-line-chart',
    url: '/reportes',
    permission: 'reports.index'
  },
  {
    title: 'Configuración',
    key: 'configuracion',
    icon: 'fa fa-gear',
    children: [
      {
        title: 'Roles',
        key: 'roles',
        url: '/configuracion/roles',
        permission: 'profiles.index'
      },
      {
        title: 'Usuarios',
        key: 'usuarios',
        url: '/configuracion/usuarios',
        permission: 'users.index'
      },
    ],
  },
]
